import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { authApi, type LoginDTO } from '../api/auth';
import { apiClient } from '../api/client';
import router from '../router';

export const useAuthStore = defineStore('auth', () => {
  const token = ref<string | null>(localStorage.getItem('admin_token'));
  const loading = ref(false);
  const error = ref<string | null>(null);

  const isAuthenticated = computed(() => !!token.value);

  const setToken = (newToken: string | null) => {
    token.value = newToken;
    apiClient.setToken(newToken);
    if (newToken) {
      localStorage.setItem('admin_token', newToken);
    } else {
      localStorage.removeItem('admin_token');
    }
  };

  const login = async (credentials: LoginDTO): Promise<void> => {
    loading.value = true;
    error.value = null;
    try {
      const response = await authApi.login(credentials);
      setToken(response.accessToken);
      router.push('/');
    } catch (err: any) {
      error.value = err.message || 'Ошибка при входе в систему';
      throw err;
    } finally {
      loading.value = false;
    }
  };

  const logout = () => {
    setToken(null);
    router.push('/login');
  };

  const checkAuth = () => {
    const storedToken = localStorage.getItem('admin_token');
    if (storedToken) {
      setToken(storedToken);
    }
  };

  return {
    token,
    loading,
    error,
    isAuthenticated,
    login,
    logout,
    checkAuth,
  };
});


